import { ReactElement } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import ScrollToTop from './component/ScrollToTop';
import Login from './pages/Home';
import Auth from './pages/Login'; // Ensure this matches your new filename 'Login.tsx'
import Pricing from './pages/Pricing';
import Library from './pages/Library';
import Unsubscribe from './pages/unsubscribe';
import MyAccount from './pages/MyAccount';
import TermsAndConditions from './pages/Terms';
import PrivacyPolicy from './pages/Privacy';
import { isAuthenticated } from './utils/authSession';
import { SubscriptionRoute } from './components/SubscriptionRoute';
import Checkout from './pages/Checkout';

const PublicAuthRoute = ({ children }: { children: ReactElement }): ReactElement => (
  isAuthenticated() ? <Navigate to="/my-account" replace /> : children
);

const PrivateRoute = ({ children }: { children: ReactElement }): ReactElement => (
  isAuthenticated() ? children : <Navigate to="/login?mode=signup" replace />
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<PublicAuthRoute><Auth /></PublicAuthRoute>} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/library" element={<SubscriptionRoute><Library /></SubscriptionRoute>} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/my-account" element={<PrivateRoute><MyAccount /></PrivateRoute>} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
         <Route path="/checkout" element={<Checkout />} />
      </Routes>
    </Router>
  );
}

export default App;
